import React, { useState, useEffect, useMemo } from "react";
import { useTheme } from '~/contexts/ThemeContext'
import { usePlp } from '~/contexts/PlpContext'

import IconClose from '~/components/icons/close'

import { aria_btn, countnum, plus_btn, bubb_btn } from "~/styles/app.module.scss"
import { test_bar } from "~/styles/plp/plp_groupsnav.module.scss"
import * as styles from "~/styles/plp/plp_bar.module.scss"


const Bar = () => {
  const { isMobile, collPanel, locate, setLocate, storesData } = useTheme()
  const {
    collection, plpHook, products,
    currGrpId, onGroup, 
    currGroup, onPanel,
    currSort, setCurrSort, 
    filters, onFilter,
    scale, handleScale, 
    singPlTiles, showGrpNav, 
    allColors
  } = usePlp()

  const { checkStoreGend } = plpHook

  const { handle, groups, group_blockers, feature_bubb } = collection
  const storeGendConflct = useMemo(() => {
    return checkStoreGend({ locate })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locate])

  const product_lines = collection.product_lines.filter(x => !!x)
  
  const get_groups = () => {
    const show_bar = !showGrpNav && !!currGroup
    if (!show_bar) return false

    const group_name = currGroup.includes('group') ? currGroup : `group${currGroup}`
    let group_objs = groups.filter(x => !!x && x.type === group_name)
    group_objs = group_objs.filter(x => !group_blockers.includes(x.mid))
    
    return group_objs || []
  }
  const groupArr = get_groups()

  const getGroupName = (id) => {
    if (!id) return false
    let group_name = id ? groups.find(x => x.mid === id) : false
    if (group_name) group_name = group_name.data.name
    return group_name
  }

  const showApplied = () => {
    return filters.length > 0 || locate?.shipIntl || currGrpId || groupFeatures().length > 0 || getStoreFilter()
  }

  const groupFeatures = () => {
    if (!feature_bubb) return false
    let features = checkFeatures(feature_bubb)
    features = features.sort((a, b) => feature_bubb.indexOf(a) - feature_bubb.indexOf(b) )

    return features
  }

  const checkFeatures = (found) => {
    let features = found.filter(filt => !filters.find(x => x.type === 'groupfeature' && x.name === filt))
    let avail = flat_prods(products).filter(x => {
      return !!x && x?.hasOwnProperty('filters') && x?.filters?.hasOwnProperty('groupfeature')
    })
    avail = [...new Set(avail.map(x => x.filters.groupfeature).flat() )]

    if (collection.handle === 'mens-tees') {
      const has_alts = flat_prods(products).filter(x => !!x.alt_cuts)
      const alt_types = [...new Set(has_alts.map(prod => prod.alt_cuts.opts.map(x => x.label)).flat() )]
      if (features.includes('Short') && alt_types.includes('Short')) avail.push('Short')
      if (features.includes('Tall') && alt_types.includes('Tall')) avail.push('Tall')
    }

    return features.filter(x => avail.includes(x))
  }

  const getStoreName = (short) => {
    const store = storesData.flatMap(x => x.stores).find(x => x.short_name === short)
    return store ? store.title : short
  }

  const countText = () => {
    const is_init = (singPlTiles && filters.length < 1) && !allColors;
    let grp = currGrpId ? `${getGroupName(currGrpId)} ` : ''
    if (currGrpId && grp !== '') grp = `${grp.split('--')[0]} `
    const colors = (currGrpId && allColors) ? 'Colors' : '';
    return `${prodsCount()} ${grp}${is_init ? 'Styles' : !allColors ? 'Items' : ''} ${filters.length > 0 ? 'Found' : colors}`
  }

  const prodsCount = () => {
    if (!products || products.length < 1) return 0
    const not_stores = locate?.currStores?.length < 1 && !locate?.shipIntl
    if (singPlTiles && (filters.length < 1 && not_stores) && !currGrpId) return product_lines.length
    let count_prods = []
    count_prods = flat_prods(products)
    count_prods = count_prods.filter(x => x.pl_pima && x.pl_pima !== 99998)
    return count_prods.length
  }

  const flat_prods = (prods) => {
    
    const cleaned = prods.flat().filter(x => !!x)
    let prodsarr
    if (cleaned.find(x => x?.hasOwnProperty('products'))) {
      prodsarr = cleaned.map(x => {
        return x?.hasOwnProperty('products') ? x.products : x
      })
      prodsarr = prodsarr.flat()
    } else {
      prodsarr = cleaned
    }
    return prodsarr.filter(x => !!x && x?.hasOwnProperty('filters'))
  }

  // const handleToggleFlat = (name) => {
  //   name === 'flat' ? localStorage.removeItem('model') : localStorage.setItem('model','true')
  //   // setTileFlat(name)
  //   setFlats(name)
  // }

  const onBubbleClick = (filter) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'bm_ga_event',
      eventCategory: 'bubble_button',
      eventAction: 'click',
      eventLabel: `${handle}: ${filter}`,
    })
    onFilter({type: 'groupfeature',name: filter})
  }

  const getStoreFilter = () => {
    if (!locate || locate?.currStores?.length < 1) return false
    if (storeGendConflct) return false

    return locate.currStores[0]
  }

  const checkFilters = () => {
    const any_filters = filters.length > 0
    const only_stores = any_filters && filters[0].type === 'locations'

    return any_filters && !only_stores
  }

  const clearStores = () => {
    setLocate({
      ...locate,
      currStores: [],
      storeGend: false
    })
  }

  const clearIntl = () => {
    setLocate({
      ...locate,
      shipIntl: false
    })
  }
  
  return (
    <div className={styles.bar} plp-bar="">
      {groupArr && (
        <div className={styles.group_curr}>
          <button 
            type="button"
            className={`${aria_btn} ${styles.group_btn}`} 
            aria-pressed={!currGrpId ? 'true' : 'false'}
            onClick={(e)=> onGroup(false)}
          >
            {(handle === 'all' || handle.includes('-all')) ? 'All' : `All ${currGroup}s`}
          </button>
          {groupArr.map( (item, index) =>
            <button 
              type="button"
              key={item.mid + item.type} 
              className={`${aria_btn} ${styles.group_btn}`} 
              aria-pressed={currGrpId === item.mid ? 'true' : 'false'}
              onClick={(e)=> onGroup(item.mid)}
            >
              {item.data.name.split('--')[0]}
            </button>
          )}
        </div>
      )}
      <div className={[styles.applied_wr, showApplied() ? styles.open : ''].join(' ')}>
        <div className={styles.applied}>
          <div className={styles.applied_btns}>
            {(locate?.shipIntl && locate?.currStores.length < 1) && (
              <button 
                type="button"
                className={`${aria_btn} ${bubb_btn}`} 
                aria-pressed={'true'}
                aria-label={'Ships internationally'}
                onClick={(e)=> clearIntl()}
              >
                SHIP INTL
                <IconClose icon_classes={''} />
              </button>
            )}
            {getStoreFilter() && (
              <button 
                type="button"
                className={`${aria_btn} ${bubb_btn}`} 
                aria-pressed={'true'}
                onClick={(e)=> clearStores()}
              >
                {getStoreName(getStoreFilter())}
                <IconClose icon_classes={''} />
              </button>
            )}
            {currGrpId && (
              <button 
                type="button"
                className={`${aria_btn} ${bubb_btn}`} 
                aria-pressed={'true'}
                onClick={(e)=> onGroup(currGrpId)}
              >
                {getGroupName(currGrpId).split('--')[0]}
                <IconClose icon_classes={''} />
              </button>
            )}
            {checkFilters() && filters.filter(x => x.type !== 'locations').map((filt,index) => 
              <button 
                type="button"
                key={`ap${filt.type}${filt.name}${index}`}
                className={`${aria_btn} ${bubb_btn}`} 
                aria-pressed={'true'}
                onClick={(e)=> onFilter(filt)}
              >
                {filt.name.split('--')[0]}
                <IconClose icon_classes={''} />
              </button>
            )}
            {(!collection.handle.includes('-all') && groupFeatures().length > 0) && groupFeatures().map(filt => 
              <button 
                type="button"
                key={`apfeat${filt}`}
                className={`${aria_btn} ${bubb_btn}`} 
                aria-pressed={'false'}
                onClick={(e)=> onBubbleClick(filt)} 
              >
                {filt.split('--')[0]}
                <IconClose icon_classes={''} />
              </button>
            )}
          </div>
        </div>
      </div>

      <div className={styles.toggles}>
        <button 
          type="button"
          className={`${aria_btn} ${styles.group_btn} ${!isMobile ? plus_btn : ''}`} 
          aria-expanded={collPanel === 'filters' ? 'true' : 'false'}
          onClick={(e) => onPanel('filters')}
        >
          <svg className={styles.icon_mfilter} viewBox="0 0 16 16">
            <path stroke="currentColor" strokeWidth="context-stroke" strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4" d="M0 4.5h16"></path>
            <path stroke="currentColor" strokeWidth="context-stroke" strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4" d="M3.5 2v5"></path>
            <path stroke="currentColor" strokeWidth="context-stroke" strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4" d="M16 11.5h-16"></path>
            <path stroke="currentColor" strokeWidth="context-stroke" strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4" d="M12.5 14v-5"></path>
          </svg>
          Filters 
          {filters.length > 0 && (
            <span className={countnum}>({filters.length})</span>
          )}
        </button>

        
        <button 
          type="button"
          className={`${aria_btn} ${styles.group_btn} ${!isMobile ? plus_btn : ''}`} 
          aria-expanded={collPanel === 'sort' ? 'true' : 'false'}
          onClick={(e) => onPanel('sort')}
        >
          Sort<span className={countnum} filts-cnt=""></span>
        </button>

        {(checkFilters() || currGrpId) && (
          <button 
            type="button"
            className={`${aria_btn} ${styles.clear}`} 
            onClick={(e) => onFilter('clear')}
          >
            <span>Clear</span>
          </button>
        )}

        {currSort && (
          <div className={test_bar}>
            <button 
              type="button"
              className={`${aria_btn} ${styles.clear}`} 
              onClick={(e) => setCurrSort(false)}
            >
              <span>CLEAR SORT</span>
            </button>
          </div>
        )}

        <div className={styles.count_flats}>
          {(isMobile) && (
            <div className={styles.scale_togg}>
              <button 
                type="button"
                className={`${aria_btn} ${styles.group_btn} ${styles[`s${scale}`]}`} 
                scale-btn=""
                onClick={(e) => handleScale()}
                aria-label="Change product tile scale"
              >
                <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
                  <rect className={[styles.sq1, styles.scale_mob].join(' ')} x="1.5" y="2.1" width="11" height="24.8" stroke="currentColor" />
                  <rect className={[styles.sq2, styles.scale_mob].join(' ')} x="16.5" y="2.1" width="11" height="24.8" stroke="currentColor" />

                  <rect className={[styles.sq1, styles.scale_desk].join(' ')} x="0.5" y="0.5" width="11" height="11" stroke="currentColor"/>
                  <rect className={[styles.sq1, styles.scale_desk].join(' ')} x="17.5" y="0.5" width="11" height="11" stroke="currentColor"/>
                  <rect className={[styles.sq1, styles.scale_desk].join(' ')} x="0.5" y="17.5" width="11" height="11" stroke="currentColor"/>
                  <rect className={[styles.sq2, styles.scale_desk].join(' ')} x="17.5" y="17.5" width="11" height="11" stroke="currentColor"/>
                </svg>
              </button>
            </div>
          )}
          <div className={styles.coll_count}>
            {countText()}
          </div>
        </div>
      </div>
    </div>
  )
};

export default Bar

// <div className={styles.under_togg} utoggs="">
//   <div className={styles.swtch_label}>
//     View 
//   </div>
//   <div className={styles.swtch_btns}>
//     <button 
//       className={`${aria_btn} ${styles.group_btn} ${(tileFlat === 'flat') ? styles.active : ''}`} 
//       onClick={(e) => handleToggleFlat('flat')}
//       utogg=""
//     >
//       Product
//     </button>
//     <button 
//       className={`${aria_btn} ${styles.group_btn} ${(tileFlat === 'model') ? styles.active : ''}`} 
//       onClick={(e) => handleToggleFlat('model')}
//       utogg=""
//     >
//       On Model
//     </button>
//   </div>
// </div>

// <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
//   <rect className={styles.sq1} x="0.5" y="0.5" width="11" height="11" stroke="currentColor"/>
//   <rect className={styles.sq2} x="17.5" y="0.5" width="11" height="11" stroke="currentColor"/>
//   <rect className={styles.sq3} x="0.5" y="17.5" width="11" height="11" stroke="currentColor"/>
//   <rect className={styles.sq3} x="17.5" y="17.5" width="11" height="11" stroke="currentColor"/>
// </svg>



